import { createFileRoute, redirect } from '@tanstack/react-router'
import Loader from '@/components/common/Loader'
import { lazy, Suspense } from 'react'

const RolesAndPermissionsFormPage = lazy(async () => {
  const module = await import(
    '@/features/city-clerk/roles-and-permissions/pages/RolesAndPermissionsFormPage/RolesAndPermissionsFormPage'
  )
  return { default: module.default }
})

export type RolesAndPermissionsNewSearch = {
  cityKey?: string
}

export const Route = createFileRoute(
  '/(app)/city-clerk/roles-and-permissions/new',
)({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      cityKey: typeof search.cityKey === 'string' ? search.cityKey : undefined,
    }
  },
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.rolesPermissionsManage) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { cityKey } = Route.useSearch()

  return (
    <Suspense
      fallback={
        <div className="h-page bg-(--color-surface) flex items-center justify-center z-9999">
          <Loader size="lg" />
        </div>
      }
    >
      <RolesAndPermissionsFormPage mode="add" initialCityKey={cityKey} />
    </Suspense>
  )
}
